module.exports = __webpack_public_path__ + "static/media/shelter.d818c0de.svg";